export const EMAIL_REGEX = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[comCOM]{3}$/;

export const validEmail = (value) => EMAIL_REGEX.test(value);
